<template>
  <div style="height:700px">
    <div>
      <el-select
        v-model="params.staffStatus"
        size="small"
        placeholder="请选择证件状态"
      >
        <el-option
          :value="value.id"
          v-for="value in $store.state.select.staffCertificateStatus"
          :key="value.id"
          :label="value.nameOne"
        ></el-option>
      </el-select>
      <el-input
        size="small"
        style="margin-left:10px"
        v-model.trim="params.diningStaffName"
        placeholder="请输入员工昵称"
      ></el-input>
      <el-button
        style="margin-left:10px;width:90px"
        type="primary"
        plain
        icon="el-icon-search"
        size="mini"
        @click="getList"
      >
        查询
      </el-button>
      <el-button
        style="margin-left:10px;width:90px"
        type="primary"
        plain
        icon="el-icon-circle-plus-outline"
        size="mini"
        @click="addList"
      >
        新增
      </el-button>
    </div>

    <el-table
      :data="responseData"
      :height="tableHeight"
      border
      style="width:100%;margin-top:20px"
    >
      <el-table-column label="姓名" prop="name" align="center" width="100">
      </el-table-column>

      <el-table-column prop="sex" label="性别" align="center" width="80">
        <template slot-scope="rowData">
          {{ $store.state.select.personnelSex[rowData.row.sex].nameOne }}
        </template>
      </el-table-column>

      <el-table-column
        prop="diningStaff"
        align="center"
        label="岗位"
        width="100"
      >
      </el-table-column>

      <el-table-column
        prop="healthCertificate"
        label="从业证件"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <el-image
            class="img-thumbnail"
            style="width:100px;height:60px"
            :src="$store.state.config.fileUrl + scope.row.healthCertificate"
            :preview-src-list="[
              $store.state.config.fileUrl + scope.row.healthCertificate
            ]"
          >
          </el-image>
        </template>
      </el-table-column>
      <el-table-column
        prop="staffStatus"
        label="证件状态"
        align="center"
        width="80"
      >
        <template slot-scope="rowData">
          {{
            $store.state.select.staffCertificateStatus[rowData.row.staffStatus].nameOne
          }}
        </template>
      </el-table-column>

      <el-table-column
        prop="healthCertificateNumber"
        align="center"
        label="证件编号"
      >
      </el-table-column>

      <el-table-column
        prop="healthCertificateDateEnd"
        label="证件有效期"
        align="center"
      >
        <template slot-scope="rowData">
          {{ $Common.dateFormatDate(rowData.row.healthCertificateDateEnd) }}
        </template>
      </el-table-column>

      <el-table-column prop="diningStaffPhone" label="联系电话" align="center">
      </el-table-column>

      <el-table-column prop="byInputtingTime" align="center" label="建档时间">
        <template slot-scope="rowData">
          {{ $Common.dateFormatDateTwo(rowData.row.byInputtingTime) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="200">
        <template slot-scope="scope">
          <el-button
            type="primary"
            plain
            size="mini"
            @click="openEditBox(scope.row)"
          >
            编辑
          </el-button>
          <el-button
            type="danger"
            plain
            size="mini"
            @click="delDataInfo(scope.row.id)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="float:right;height:30px"
      :page-size="params.pageSize"
      :pager-count="5"
      layout="prev, pager, next"
      @current-change="currentChange"
      :total="total"
    >
    </el-pagination>
    <el-dialog
      width="60%"
      :title="type == 'add' ? '新增人员' : '修改人员'"
      :visible.sync="addOrEdit"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <div style="height:550px">
        <el-form
          :model="editDataInfo"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="姓名">
                <el-input
                  style="width:100%"
                  size="small"
                  v-model.trim="editDataInfo.diningStaffName"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="性别">
                <el-select
                  style="width:100%;"
                  size="small"
                  v-model="editDataInfo.diningStaffSex"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in $store.state.select.personnelSex"
                    :key="item.id"
                    :label="item.nameOne"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系电话">
                <el-input
                  style="width:100%"
                  size="small"
                  v-model.trim="editDataInfo.diningStaffPhone"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="岗位">
                <el-input
                  style="width:100%"
                  size="small"
                  v-model.trim="editDataInfo.diningStaff"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="食品管理员">
                <el-radio-group
                  size="small"
                  v-model="editDataInfo.diningStaffAdmin"
                >
                  <el-radio-button value="0" label="0">否</el-radio-button>
                  <el-radio-button value="1" label="1">是</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="健康证证件号">
                <el-input
                  style="width:100%"
                  size="small"
                  v-model.trim="editDataInfo.healthCertificateNumber"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="证件到期时间">
                <el-date-picker
                  v-model="editDataInfo.healthCertificateDateEnd"
                  type="date"
                  size="small"
                  style="width:100%"
                  value-format="timestamp"
                  format="yyyy 年 MM 月 dd 日"
                  placeholder="请选择证件到期时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="体检日期">
                <el-date-picker
                  v-model="editDataInfo.healthCertificateDate"
                  type="date"
                  size="small"
                  style="width:100%"
                  format="yyyy 年 MM 月 dd 日"
                  value-format="timestamp"
                  placeholder="请选择体检日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="健康证图片">
                <el-image
                  class="img-thumbnail"
                  v-if="editDataInfo.healthCertificate"
                  style="width:100px;height:60px"
                  :src="
                    $store.state.config.fileUrl +
                      editDataInfo.healthCertificate
                  "
                >
                </el-image>
                <div class="col-sm-10">
                  <label for="img_file">
                    <input
                      type="file"
                      id="img_file"
                      @change="imgUpload($event, 1)"
                    />
                    <span class="btn btn-info btn-sm">
                      <i class="el-icon-circle-plus"></i>
                      点击上传
                    </span>
                  </label>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="editDataInfo.diningStaffAdmin == 1">
              <el-form-item label="管理员证书">
                <el-image
                  class="img-thumbnail"
                  v-if="editDataInfo.foodSafetyCertificate != ''"
                  style="width:100px;height:60px"
                  :src="
                    $store.state.config.fileUrl +
                      editDataInfo.foodSafetyCertificate
                  "
                >
                </el-image>
                <div class="col-sm-10">
                  <label for="img_file_tow">
                    <input
                      type="file"
                      id="img_file_tow"
                      @change="imgUpload($event, 2)"
                    />
                    <span class="btn btn-info btn-sm">
                      <i class="el-icon-circle-plus"></i>
                      点击上传
                    </span>
                  </label>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="editDataInfo.diningStaffAdmin == 1">
            <el-col :span="12">
              <el-form-item label="证件号">
                <el-input
                  style="width:100%"
                  size="small"
                  v-model.trim="editDataInfo.certificateNumber"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="证件有效期">
                <el-date-picker
                  v-model="editDataInfo.validityAdministratorCertificate"
                  type="date"
                  size="small"
                  style="width:100%"
                  value-format="timestamp"
                  format="yyyy 年 MM 月 dd 日"
                  placeholder="请选择有效期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <hr style="margin-top:0px" />
        <div class="button-group">
          <el-button
            class="button"
            type="primary"
            size="mini"
            @click="saveData('ruleForm')"
          >
            保存
          </el-button>
          <el-button
            class="button"
            type="primary"
            size="mini"
            @click="cencel('ruleForm')"
          >
            取消
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  nane: "StaffList",
  props: {
    id: {
      type: Number
    }
  },
  data() {
    return {
      tableHeight: 600,
      params: {
        pageSize: 20,
        pageNum: 1,
        diningRoomId: this.id,
        staffStatus: "",
        diningStaffName: ""
      },
      responseData: [],
      total: 0,
      addOrEdit: false,
      editDataInfo: {
        diningRoomId: this.id,
        diningStaffName: "", //姓名
        diningStaffSex: "", //性别
        diningStaffPhone: "", //联系电话
        diningStaff: "", //岗位
        diningStaffAdmin: "0", //是否为食品管理员
        healthCertificate: "", //健康证图片,
        healthCertificateNumber: "", //健康证证件号
        healthCertificateDate: "", //体检日期
        healthCertificateDateEnd: "", //证件到期日
        foodSafetyCertificate: "", //食品安全管理员证书
        certificateNumber: "", //食品安全管理员证证件号
        validityAdministratorCertificate: "" //食品安全管理员证有效期
      },
      type: "",
      rules: {}
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 获取数据列表
    async getList() {
      let res = await this.$Http.getCanteenStaffList(this.params, true);
      if (res.code == 200) {
        this.responseData = res.data.list;
        this.total = res.data.total;
      } else if (res.code == 101) {
        this.responseData.total = 0;
        this.responseData.list = [];
      } else {
        this.responseData.total = 0;
        this.responseData.list = [];
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 新增
    addList() {
      this.type = "add";
      this.addOrEdit = true;
    },
    currentChange(val) {
      this.params.pageNum = val;
      this.getList();
    },
    // 修改
    openEditBox(row) {
      this.type = "edit";
      this.addOrEdit = true;
      let obj = {};
      obj.id = row.id || "";
      obj.diningStaffName = row.name;
      obj.diningStaffSex = row.sex;
      obj.diningStaffPhone = row.diningStaffPhone;
      obj.diningStaff = row.diningStaff;
      obj.diningStaffAdmin = row.diningStaffAdmin;
      obj.healthCertificate = row.healthCertificate;
      obj.healthCertificateNumber = row.healthCertificateNumber;
      obj.healthCertificateDate = Date.parse(new Date());
      if (row.healthCertificateDate != 0 || row.healthCertificateDate != "") {
        obj.healthCertificateDate = row.healthCertificateDate * 1000;
      }

      obj.healthCertificateDateEnd = Date.parse(new Date());
      if (
        row.healthCertificateDateEnd != 0 ||
        row.healthCertificateDateEnd != ""
      ) {
        obj.healthCertificateDateEnd = row.healthCertificateDateEnd * 1000;
      }

      obj.foodSafetyCertificate = row.foodSafetyCertificate;
      obj.certificateNumber = row.certificateNumber;
      obj.validityAdministratorCertificate =
        row.validityAdministratorCertificate * 1000;

      obj.validityAdministratorCertificate = Date.parse(new Date());
      if (
        row.validityAdministratorCertificate != 0 ||
        row.validityAdministratorCertificate != ""
      ) {
        obj.validityAdministratorCertificate =
          row.validityAdministratorCertificate * 1000;
      }
      this.editDataInfo = Object.assign({}, obj);
    },
    saveData(formName) {
      var newParamData = Object.assign({}, this.editDataInfo);
      if (newParamData.healthCertificateDate == "") {
        this.$message({
          type: "warning",
          message: "请选择体检日期"
        });
        return false;
      }
      if (newParamData.healthCertificateDateEnd == "") {
        this.$message({
          type: "warning",
          message: "请选择证件到期时间"
        });
        return false;
      }
      if (newParamData.diningStaffAdmin == 0) {
        delete newParamData.foodSafetyCertificate;
        delete newParamData.certificateNumber;
        delete newParamData.validityAdministratorCertificate;
      } else {
        if (newParamData.validityAdministratorCertificate == "") {
          this.$message({
            type: "warning",
            message: "请选择食品安全管理员证有效期"
          });
          return false;
        }
        newParamData.validityAdministratorCertificate = parseInt(
          newParamData.validityAdministratorCertificate / 1000
        );
      }
      newParamData.healthCertificateDate = parseInt(
        newParamData.healthCertificateDate / 1000
      );
      newParamData.healthCertificateDateEnd = parseInt(
        newParamData.healthCertificateDateEnd / 1000
      );
      if (this.type == "add") {
        this.addDataAction(newParamData);
      } else {
        this.editDataAction(newParamData);
      }
    },
    // 新增数据操作
    async addDataAction(newParamData) {
      let res = await this.$Http.addCanteenStaff(newParamData, true);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.messsage || "新增成功"
        });
        this.addOrEdit = false;
        this.refeashData();
        this.getList();
      } else {
        this.$message({
          type: "error",
          message: res.messsage || "新增失败"
        });
      }
    },
    // 修改数据操作
    async editDataAction(newParamData) {
      let res = await this.$Http.editCanteenStaff(newParamData);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.messsage || "修改成功"
        });
        this.addOrEdit = false;
        this.refeashData();
        this.getList();
      } else {
        this.$message({
          type: "error",
          message: res.messsage || "修改失败"
        });
      }
    },
    cencel(formName) {
      this.addOrEdit = false;
      this.refeashData();
    },
    // 删除
    delDataInfo(val) {
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var requestData = {
            employeeId: [val]
          };
          let res = await this.$Http.delCanteenStaff(requestData);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.messsage || "删除成功"
            });
            this.getList();
          } else {
            this.$message({
              type: "error",
              message: res.messsage || "删除失败"
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    refeashData() {
      this.editDataInfo = {
        diningRoomId: this.id,
        diningStaffName: "", //姓名
        diningStaffSex: "", //性别
        diningStaffPhone: "", //联系电话
        diningStaff: "", //岗位
        diningStaffAdmin: "0", //是否为食品管理员
        healthCertificate: "", //健康证图片,
        healthCertificateNumber: "", //健康证证件号
        healthCertificateDate: "", //体检日期
        healthCertificateDateEnd: "", //证件到期日
        foodSafetyCertificate: "", //食品安全管理员证书
        certificateNumber: "", //食品安全管理员证证件号
        validityAdministratorCertificate: "" //食品安全管理员证有效期
      };
    },
    // 图片上传
    async imgUpload(event, cate) {
      var uploadInfo = await this.$Common.fileUpload(event);
      if (uploadInfo) {
        switch (cate) {
          case 1:
            this.editDataInfo.healthCertificate = uploadInfo.fileUrl;
            break;
          case 2:
            this.editDataInfo.foodSafetyCertificate = uploadInfo.fileUrl;
            break;
        }
      }
    }
  },
  watch: {
    id: function(nval) {
      this.params.diningRoomId = nval;
      this.getList();
    }
  }
};
</script>
<style lang="scss" scoped>
.button-group {
  float: right;
  .button {
    width: 90px;
  }
}
</style>
